import { useState } from "react";
import { InvoiceDrawer } from "./Components/InvoiceDrawer";
import { InvoiceListResponseType } from "@sellar-io/api-v2/types";
import { InvoicesTable } from "./Components/InvoicesTable";
import { InvoicesCardList } from "./Components/InvoicesCardList";
import { FinanceSettingsLayout } from "./Components/FinanceSettingsLayout";
import { useMediaQuery } from "usehooks-ts";
import { TableHeader } from "../../../components/table/TableHeader";
import { InvoicesFilter } from "./Components/InvoicesFilter";
import { Tag } from "../../../components/tag/Tag";
import { capitalize } from "@sellar-io/common";
import { useDebounce } from "use-debounce";
import { useInvoicesFilterStore } from "./stores/InvoicesFilterStore";
import { useShallow } from "zustand/shallow";

export const FinanceSettingsInvoices = () => {
  const [active, setActive] = useState(false);
  const [selectedInvoice, setSelectedInvoice] =
    useState<InvoiceListResponseType[number]>();
  const [search, setSearch] = useState("");
  const [desktopFilter, setDesktopFilter] = useState(false);
  const [mobileFilter, setMobileFilter] = useState(false);

  const [debouncedSearchValue] = useDebounce(search, 500);

  const state = useInvoicesFilterStore(useShallow((state) => state));

  const isDesktop = useMediaQuery("(min-width: 1200px)");

  return (
    <FinanceSettingsLayout>
      <div className="container mx-auto mt-6 max-w-[1300px]">
        <TableHeader
          desktopFilterActive={desktopFilter}
          setDesktopFilterActive={setDesktopFilter}
          filter={
            <InvoicesFilter
              onDismiss={() => {
                setDesktopFilter(false);
                setMobileFilter(false);
              }}
            />
          }
          mobileFilterActive={mobileFilter}
          setMobileFilterActive={setMobileFilter}
          search={search}
          searchPlaceholder="Search invoice #..."
          setSearch={setSearch}
          tags={
            state.status &&
            state.status !== "all" && (
              <Tag
                className="mt-2 flex items-center gap-1"
                onClick={() => state.setStatus("all")}
              >
                {capitalize(state.status.replace(/_/g, " "))}
              </Tag>
            )
          }
        />
        {isDesktop ? (
          <InvoicesTable
            setSelectedInvoice={setSelectedInvoice}
            setActive={setActive}
            search={debouncedSearchValue}
          />
        ) : (
          <InvoicesCardList
            setSelectedInvoice={setSelectedInvoice}
            setActive={setActive}
            search={debouncedSearchValue}
          />
        )}
      </div>
      <InvoiceDrawer
        active={active}
        setActive={setActive}
        invoice={selectedInvoice}
      />
    </FinanceSettingsLayout>
  );
};
